// extracted by mini-css-extract-plugin
export default {"containerShadow":"hiudGJaYyl1mKU0X-x1aq"};